import { BodySmall } from '#/components/Text/BodySmall';
import { useI18n } from '#/i18n/hooks/useI18n';
import { colors, spacing } from '#/theme/theme';

export function WydSuccessApplicationMessage() {
  const { i18n } = useI18n();

  return (
    <div
      style={{
        marginBottom: spacing[16],
        display: 'flex',
        flexDirection: 'column',
        gap: spacing[16],
      }}
    >
      <div
        style={{
          background: colors.lightSage,
          border: `1px solid ${colors.brandGreen}`,
          borderRadius: 8,
          textAlign: 'center',
          padding: spacing[8],
        }}
      >
        {i18n('Thank you! We received your response.')}
      </div>

      <BodySmall>
        {i18n(
          'Please create your Idealist account so you can log in anytime. Choose a sign-up option, or set a password below.',
        )}
      </BodySmall>
    </div>
  );
}
